// extracted by mini-css-extract-plugin
module.exports = {"location":"styles_location__144Af","photo":"styles_photo__Ts-5Q","profileIcon":"styles_profileIcon__2-seR"};